/* eslint-disable import/no-anonymous-default-export */

import { useContext, useCallback } from 'react';
import { AjaxContext, formatListData } from 'commons-ui';
import _get from 'lodash/get';
import _map from 'lodash/map';
import { INoticeBoard } from '../interfaces';

const useService = () => {
	const { postData } = useContext(AjaxContext);
	const getNoticesData = useCallback(
		async ({
			pageDetails,
			app,
			sortDetails,
			filterDetails
		}: {
			pageDetails: any;
			app: any;
			sortDetails: any;
			filterDetails: any;
		}) => {
			const { appName } = app;
			const result = await postData({
				endpoint: '/marketing/dashboard/notices/getNotices',
				queryParams: {
					appName
				},
				body: {
					page: pageDetails,
					filters: filterDetails,
					sortInfoArray: sortDetails
				}
			});
			let data = _get(result, ['data', 'data', 'notices'], []);
			data = _map(data, (row) => {
				const newRow = row;
				if (newRow?.cta) {
					newRow.ctaType = newRow.cta?.type;
					newRow.ctaValue = newRow.cta?.value;
					newRow.ctaSelectValue = newRow.cta?.value;
				}

				if (newRow?.subtitle) {
					newRow.subtitleText = newRow.subtitle.text;
					newRow.subtitleColor = newRow.subtitle.color;
					delete newRow.subtitle;
				}

				if (newRow?.title) {
					newRow.titleText = newRow.title.text;
					newRow.titleColor = newRow.title.color;
					delete newRow.title;
				}

				if (newRow?.cardBg) {
					newRow.cardBgColor = newRow.cardBg?.color;
					newRow.cardBgUrl = newRow.cardBg?.url;
					delete newRow.cardBg;
				}

				if (newRow?.inclusiveSegments) {
					newRow.inclusiveSegments = newRow?.inclusiveSegments.join(',');
				}
				if (newRow?.exclusiveSegments) {
					newRow.exclusiveSegments = newRow?.exclusiveSegments.join(',');
				}
				if (newRow?.videoMeta) {
					newRow.videoUrl = newRow?.videoMeta.url;
					newRow.videoDuration = newRow?.videoMeta.duration;
					delete newRow.videoMeta;
				}
				return newRow;
			});
			const rowCount = _get(result, ['data', 'data', 'count'], 0);
			const listData = formatListData(data);
			return { rowCount, data: listData };
		},
		[]
	);

	const requestCreateNotice = useCallback((appName: string, data: INoticeBoard) => {
		return postData({
			endpoint: '/marketing/dashboard/notices/createNotice',
			body: { notice: data },
			queryParams: {
				appName
			}
		});
	}, []);

	const requestUpdateNotice = useCallback((appName: string, data: INoticeBoard) => {
		return postData({
			endpoint: '/marketing/dashboard/notices/updateNotice',
			body: { notice: data },
			queryParams: {
				appName
			}
		});
	}, []);

	return {
		getNoticesData,
		requestUpdateNotice,
		requestCreateNotice
	};
};

export default useService;
